import React, { useEffect, useState } from 'react';
import './PictureSlider.css';

const defaultImages = [
  '/dog-photos/IMG_0012.JPG',
  '/dog-photos/IMG_0037.JPG',
  '/dog-photos/IMG_0978.jpeg',
  '/dog-photos/IMG_1141.jpeg',
  '/dog-photos/IMG_1188.jpeg',
  '/dog-photos/IMG_1234.jpeg',
  '/dog-photos/IMG_1368.jpeg',
  '/dog-photos/IMG_1372.jpeg',
  '/dog-photos/IMG_1644.jpeg',
  '/dog-photos/IMG_2389.jpeg',
  '/dog-photos/IMG_2463.jpeg',
  '/dog-photos/IMG_4108.jpeg',
  '/dog-photos/IMG_4197.jpeg',
  '/dog-photos/IMG_6285.jpeg',
  '/dog-photos/IMG_7821.jpeg',
  '/dog-photos/IMG_8015.jpeg',
  '/dog-photos/IMG_8126.jpeg',
  '/dog-photos/IMG_8263.JPG',
  '/dog-photos/IMG_8346.jpeg',
  '/dog-photos/IMG_8455.jpeg',
  '/dog-photos/IMG_9762.jpeg',
  '/dog-photos/IMG_9764.jpeg',
  '/dog-photos/IMG_9973.jpeg'
];

const PictureSlider = ({ images = defaultImages }) => {
  const [current, setCurrent] = useState(0);
  const [isPortraitMobile, setIsPortraitMobile] = useState(false);
  const total = images.length;

  useEffect(() => {
    const mediaQuery = window.matchMedia('(max-width: 768px)');

    const syncViewportMode = () => {
      setIsPortraitMobile(mediaQuery.matches);
    };

    syncViewportMode();
    mediaQuery.addEventListener('change', syncViewportMode);

    return () => {
      mediaQuery.removeEventListener('change', syncViewportMode);
    };
  }, []);

  // Show one image at a time on portrait mobile to prevent horizontal overflow.
  const getVisibleImages = () => {
    const visibleCount = isPortraitMobile ? 1 : 3;
    if (total <= visibleCount) return images;
    let visible = [];
    for (let i = 0; i < visibleCount; i++) {
      visible.push(images[(current + i) % total]);
    }
    return visible;
  };

  const nextSlide = () => setCurrent((prev) => (prev + 1) % total);
  const prevSlide = () => setCurrent((prev) => (prev - 1 + total) % total);

  useEffect(() => {
    if (total <= 1) {
      return undefined;
    }

    const intervalId = setInterval(() => {
      setCurrent((prev) => (prev + 1) % total);
    }, 8000);

    return () => clearInterval(intervalId);
  }, [total]);

  if (total === 0) {
    return null;
  }

  return (
    <section className="picture-slider">
      <h2>My Furry Friends!</h2>
      <div className="slider-container">
        <button className="slider-btn" onClick={prevSlide}>&lt;</button>
        {getVisibleImages().map((img, idx) => (
          <img key={`${img}-${idx}`} src={img} alt={`Slide ${current + idx + 1}`} className="slider-img" />
        ))}
        <button className="slider-btn" onClick={nextSlide}>&gt;</button>
      </div>
      <div className="slider-dots">
        {images.map((_, idx) => (
          <span
            key={idx}
            className={idx === current ? 'dot active' : 'dot'}
            onClick={() => setCurrent(idx)}
          />
        ))}
      </div>
    </section>
  );
};

export default PictureSlider;
